<style scoped lang="scss">
  .payment-form-page {

  }
</style>

<template>
  <div class="payment-form-page">
    <payment-form v-if="!loadingState.initial"/>
  </div>
</template>

<script>
import * as Sentry from '@sentry/browser'
import PaymentForm from '@components/AppComponents/PaymentPage/PaymentForm'

export default {
  name: 'PaymentFormPage',
  components: {
    PaymentForm,
  },
  props: {
    clientId: {
      type: [String, Number],
      default: null,
    },
    data: {
      type: String,
      default: null,
    },
    signature: {
      type: String,
      default: null,
    },
  },
  methods: {
    ...mapActions('currencies', ['fetchCurrencies']),
    ...mapActions('payment', ['fetchPaymentMethods', 'setPaymentData']),
    ...mapMutations('payment', {
      setPaymentCredentials: 'SET_PAYMENT_CREDENTIALS',
    }),
  },
  async created() {
    this.setPaymentCredentials({
      clientId: this.clientId,
      signature: this.signature,
      data: this.data,
    })

    try {
      const paymentData = JSON.parse(atob(this.data))

      await this.fetchCurrencies(paymentData.type)

      this.setPaymentData(paymentData)
        .then(async () => {
          await this.fetchPaymentMethods()

          this.$emit('load')
        })
        .catch(error => {
          Sentry.captureException(new Error('[PaymentFormPage] setPaymentData error', { cause: error }))

          return this.$router.replace({ name: 'not-found-page' })
        })
        .finally(() => {
          this.loadingState.initial = false
        })
    } catch (error) {
      Sentry.captureException(new Error('[PaymentFormPage] init error', { cause: error }))

      this.loadingState.initial = false

      return this.$router.replace({ name: 'not-found-page' })
    }
  },
}
</script>
